import React, {useState, useEffect, useRef} from 'react'
import { useParams, useNavigate } from 'react-router'

// Heartbeat
import { Heartbeat } from "../helpers/heartbeat";
import { usePageView } from "@usermaven/react";

import ABIGAIL from './profiles/ABIGAIL';
import JEREMY from './profiles/JEREMY';
import MARK from './profiles/MARK';

type AcceptedProfiles = "ABIGAIL" | "JEREMY" | "MARK";

interface ContentHandlerProps {
  triggerTransition: (to: string) => void;
}


const ContentHandler: React.FC<ContentHandlerProps> = ({ triggerTransition }) => {
  const navigate = useNavigate();
  const myParams = useParams();
  usePageView();

  // Controller for instance Heartbeat
  const myHeartbeat = useRef<Heartbeat | null>(null);

  const [myProfile, setMyProfile] = useState<AcceptedProfiles>()
  const [remainingTime, setRemainingTime] = useState<Number | null>(null);
  const [askisngStillThere, setAskisngStillThere] = useState<Boolean | null>(
    null
  );

  useEffect(() => {
    if(myParams.name){
      setMyProfile(myParams.name as AcceptedProfiles)

      const heartbeat: any = new Heartbeat(
        10 * 1000,
        handleTimeout,
        handleTick,
        setAskisngStillThere
      );
      
      heartbeat.start();

      myHeartbeat.current = heartbeat;

    }
  }, [myParams.name])

  const handleTimeout = () => {
    // navigate("/menu")
  };

  const handleTick = (remainingTime: any) => {
    return setRemainingTime(remainingTime)
  };

  return (
    <div>

      {myProfile === "ABIGAIL" && 
        <ABIGAIL onExit={triggerTransition} />
      }

      {myProfile === "JEREMY" && 
        <JEREMY onExit={triggerTransition}/>
      }

      {myProfile === "MARK" && 
        <MARK onExit={triggerTransition}/>
      }

    </div>
  )
}

export default ContentHandler